import { Link } from "react-router-dom";

import { useT } from "../../i18n/I18nContext";
import ErrorIllustration from "./ErrorIllustration";

// 404 page. Shares the centred-card layout + SVG illustration with
// ErrorPage so the two "you can't be here" surfaces feel like one
// family rather than two unrelated routes.
export default function NotFound() {
  const t = useT();
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg text-text px-4 sm:px-6 lg:px-12 py-12">
      <div className="w-full max-w-lg rounded-2xl border border-border bg-surface shadow-sm px-6 py-10 sm:px-10 sm:py-12 text-center">
        <ErrorIllustration
          variant="notfound"
          className="mx-auto h-44 w-auto mb-6"
        />
        <p className="text-xs uppercase tracking-[0.14em] text-secondText mb-2">
          {t("not_found.eyebrow")}
        </p>
        <h1 className="text-2xl sm:text-3xl font-bold mb-3 break-words">
          {t("not_found.title")}
        </h1>
        <p className="text-secondText mb-6 break-words">
          {t("not_found.body")}
        </p>
        <Link
          to="/"
          className="w-full sm:w-auto app-button-primary inline-flex items-center justify-center"
        >
          {t("not_found.go_home")}
        </Link>
      </div>
    </div>
  );
}
